/** Resolve a path under `public/` against the deploy base (`/main/`). */
export function asset(path: string): string {
  return import.meta.env.BASE_URL + path.replace(/^\/+/, '');
}
